import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { editUpstreamUnitConfig, getUpstreamUnitConfig } from "@/service/appList";
export default {
  name: "AppDetailTab2-third",
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      form: {
        upstreamUnitKey: "",
        upstreamAppKey: "",
        upstreamAppSecret: ""
      },
      yypzConfig: [{
        title: "upstreamUnitKey",
        key: "upstreamUnitKey",
        rules: [{
          required: true,
          message: $t("ku1j52h", "upstreamUnitKey必填"),
          trigger: "blur,change"
        }]
      }, {
        title: "upstreamAppKey",
        key: "upstreamAppKey",
        rules: [{
          required: true,
          message: $t("6773njg", "upstreamAppKey必填"),
          trigger: "blur,change"
        }]
      }, {
        title: "upstreamAppSecret",
        key: "upstreamAppSecret",
        rules: [{
          required: true,
          message: $t("5ahoj", "upstreamAppSecret必填"),
          trigger: "blur,change"
        }]
      }]
    };
  },
  computed: {
    // 第三方钉钉
    _isThirdDingDing() {
      return this.detail.appId === "ID_UPSTREAM_DING_TALK";
    },
    // 企业微信
    _isEnterpriseWechat() {
      return this.detail.appId === "ID_UPSTREAM_WECHAT_WORK_PRIVATE";
    },
    // 企业微信通讯录同步应用
    _isEnterpriseWechatSync() {
      return this.detail.appId === "ID_UPSTREAM_WECHAT_WORK_SYNC";
    },
    // 上游系统标识
    _upstream() {
      let value = "";
      if (this._isThirdDingDing) {
        value = "DING_TALK";
      } else if (this._isEnterpriseWechat || this._isEnterpriseWechatSync) {
        value = "WE_CHAT_WORK_PRIVATE";
      }
      return value;
    },
    // 报表参数
    _config() {
      // 只有微信才是全部
      return this.yypzConfig.filter(v => {
        if (v.key === "upstreamUnitKey") {
          return true;
        } else {
          if (this._isEnterpriseWechat || this._isEnterpriseWechatSync) {
            return true;
          }
        }
      });
    }
  },
  mounted() {
    this.getInit();
  },
  methods: {
    /*
     * 获取初始值
     */
    async getInit() {
      // 仅企业微信通讯录同步应用按 appId 查询配置，避免影响普通企业微信应用。
      const appId = this._isEnterpriseWechatSync ? this.detail.appId : undefined;
      const res = await getUpstreamUnitConfig(this._upstream, appId);
      if (res.data && res.data.result == 0) {
        this.form = res.data.retVal;
      }
    },
    /*
     * 保存
     */
    async yypzChange() {
      this.$refs.yypz.validate(async val => {
        if (val) {
          const params = {
            ...this.form
          };
          this.loading = true;
          // 同步应用需指定 appId，避免将凭据保存到普通企微应用。
          const appId = this._isEnterpriseWechatSync ? this.detail.appId : undefined;
          const res = await editUpstreamUnitConfig(this._upstream, params, appId);
          this.loading = false;
          if (res.data && res.data.result == 0) {
            this.$Message.success(res.data.msg);
          }
        }
      });
    }
  }
};